// Resource definition for React Admin
export const feeTemplatesResource = {
  name: '費用範本',
  fields: {
    id: 'ID',
    name: '名稱',
    description: '說明',
    type: '類型',
    currency: '貨幣',
    components: '組件',
    usage: '使用情況',
    active: '啟用',
    isActive: '啟用',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    systemTemplate: '系統範本',
    customTemplate: '自訂範本',
    feeSchedule: '費用排程',
    feeSchedules: '費用排程',
    version: '版本',
    usageCount: '使用中的排程',
    feeStructure: '費用結構',
  },
};

// Custom fee templates translations (used in custom components)
export const feeTemplates = {
  name: '費用範本',
  fields: {
    id: 'ID',
    name: '名稱',
    description: '說明',
    currency: '貨幣',
    version: '版本',
    isActive: '啟用',
    active: '啟用',
    createdAt: '建立時間',
    updatedAt: '更新時間',
    usage: '使用情況',
    usageCount: '使用中的排程',
    feeSchedule: '費用排程',
    feeSchedules: '費用排程',
    amount: '金額',
    rate: '費率',
    rateName: '費率名稱',
    rateAmount: '費率金額',
    unit: '單位',
    timeWindows: '時間窗口',
    allTimes: '全時段',
    freeMinutes: '免費分鐘',
    graceMinutes: '寬限期（分鐘）',
    maxPerSession: '每次時段最高費用',
    maxPerSessionHelper: '每次時段的可選最高費用',

    type: '類型',
    components: '組件',
    systemTemplate: '系統範本',
    customTemplate: '自訂範本',
    date: '日期',
    rateMultiplier: '費率倍數',
    effectiveDate: '生效日期',
    createdBy: '建立者',
    status: '狀態',
    reason: '原因',
    oneOffAmount: '一次性金額',
    ratePerMinute: '每分鐘費率',
    pricePerKwh: '每度電價格',
    timeUnit: '時間單位',
    perMinute: '每分鐘',
    perHour: '每小時',
    ratePerUnit: '每單位費率',
    maxChargeMinutes: '最長充電時間（分鐘）',
    noLimitPreAuthAmount: '預授權金額',
  },
  components: {
    sessionFee: '時段費',
    energyFee: '電費',
    timeFee: '時間費',
    idleFee: '閒置費',
    reservationFee: '預約費',
    enabled: '已啟用',
    disabled: '已停用',
    enable: '啟用',
    energyRates: '電費費率',
    specialDates: '特殊日期',
    noRates: '未配置費率',
    energyTimeExclusiveHelp: '能源費與時間費互相排斥（兩者皆按用量計費）。',
    timeRates: '時間費率',
  },
  rateTypes: {
    peak: '尖峰',
    'off-peak': '離峰',
    'mid-peak': '半尖峰',
    'super-off-peak': '超離峰',
    standard: '標準',
    weekend: '週末',
    weekday: '平日',
    overnight: '夜間',
    daytime: '日間',
    evening: '傍晚',
  },
  create: {
    title: '建立費用範本',
    subtitle: '定義可重複使用的費用結構',
    backToList: '返回費用範本',
    infoMessage: '建立費用範本以定義可套用於多個排程的可重複使用定價結構。',
    basicInfo: '基本資訊',
    nameHelper: '此範本的描述性名稱',
    currencyHelper: '此範本中所有費用的貨幣',
    descriptionHelper: '此範本的可選說明',
    feeStructure: '費用結構',
  },
  edit: {
    title: '編輯 %{name}',
    subtitle: '修改費用範本配置',
    backToList: '返回費用範本',
    basicInfo: '基本資訊',
    feeStructure: '費用結構',
    statusInfo: '狀態資訊',
    usageWarning: '此範本被 %{count} 個費用排程使用。變更將影響使用此範本的所有排程。',
    nameHelper: '此範本的描述性名稱',
    currencyHelper: '建立後無法更改貨幣',
    descriptionHelper: '此範本的可選說明',
  },
  show: {
    title: '費用範本詳情',
    subtitle: '查看範本配置和使用情況',
    backToList: '返回費用範本',
    basicInfo: '基本資訊',
    feeStructure: '費用結構',
    usage: '使用資訊',
    noSchedules: '此範本目前未被任何排程使用。',
    schedulesUsing: '使用此範本的排程',
    metadata: '中繼資料',
    scheduledChanges: '排程變更',
    scheduledChangesInfo: '排程在未來日期生效的變更',
  },
  list: {
    title: '費用範本',
    filters: {
      search: '按名稱搜尋',
      currency: '貨幣',
      activeOnly: '僅啟用',
      isSystem: '範本類型',
      systemTemplates: '系統範本',
      customTemplates: '自訂範本',
      all: '全部',
      active: '啟用',
      inactive: '停用',
    },
  },
  notifications: {
    created: '費用範本建立成功',
    updated: '費用範本更新成功',
    deleted: '費用範本刪除成功',
    changeScheduled: '費用範本變更排程成功',
    scheduleFailed: '費用範本變更排程失敗',
  },
  validation: {
    effectiveDateRequired: '生效日期為必填',
    idleFeeRatePositive: '啟用閒置費時，費率必須大於 0',
    idleFeeGraceMinutesInteger: '啟用閒置費時,寬限分鐘必須為非負整數',
    sessionFeeAmountNonNegative: '啟用時服務費金額必須大於或等於 0。',
    timeFeeUnitRequired: '請選擇時間單位（分鐘或小時）。',
    timeFeeRatesRequired: '啟用時間費時請至少新增一個時間費率。',
    timeFeeRatePositive: '每個時間費率必須大於 0。',
    timeFeeFreeMinutesInteger: '免費分鐘數必須為非負整數。',
    timeFeeMaxChargeMinutesNonNegative: '最長充電時間必須大於或等於 0。',
    timeFeePreAuthNonNegative: '預授權金額必須大於或等於 0。',
    energyTimeMutuallyExclusive: '能源費與時間費不能同時啟用，請選擇一種用量計費。',
  },
  schedule: {
    title: '排程費用範本變更',
    info: '排程此費用範本的變更在未來日期生效',
    effectiveDate: '生效日期',
    effectiveDateHelper: '這些變更將生效的時間',
    reason: '變更原因',
    reasonHelper: '此變更的可選原因',
    warning: '排程的變更將在指定時間自動套用',
  },
  tooltips: {
    sessionFee: '每次充電時段開始時收取的固定費用',
    energyFee: '基於消耗電量（kWh）的費用',
    timeFee: '基於充電時段持續時間的費用',
    idleFee: '充電完成後車輛仍保持連接時收取的費用',
    idleFeeEnabledDisabled: '停用時，使用者在充電完成後不會看到寬限期畫面，亦不會收取閒置費。若希望充電完成即時收費，請啟用並將寬限分鐘設為 0。',
    reservationFee: '預先預約充電位的費用',
  },
  actions: {
    addRate: '新增費率',
    removeRate: '移除費率',
    addTimeRange: '新增時段',
    removeTimeRange: '移除時段',
    saveNow: '立即儲存',
    scheduleChange: '排程變更',
    confirmSchedule: '排程變更',
  },
  sessionFee: {
    amountHelper: '每次時段收取的固定金額',
  },
  energyFee: {
    nameHelper: '此費率的名稱（例如：尖峰、離峰）',
    rateHelper: '每度電消耗的價格',
    timeRange: '時段',
    appliesAllTime: '全時段適用',
    allTimeHelper: '此費率全天候適用',
    startTime: '開始時間',
    endTime: '結束時間',
    timeRangeHelper: '此費率適用的時段',
    addTimeRange: '新增時段',
    explanation: '為不同時段定義不同費率',
  },
  timeFee: {
    rateHelper: '每分鐘充電收取的金額',
    maxChargeMinutesHelper: '達到此充電分鐘數時自動停止（0 = 無限制）。',
    preAuthHelper: '無限時段的預授權金額（0 = 不預扣）。',
  },
  idleFee: {
    rateHelper: '寬限期過後每分鐘收取的金額',
  },
  reservationFee: {
    enableHelper: '啟用後，使用者可預約此充電器。停用後，將不允許預約。',
    amountHelper: '預約時自錢包凍結的金額。設為 0 可允許無費用預約。',
    zeroAmountNote: '金額為 0 — 預約將允許但不凍結錢包。政策規則（取消期限等）仍然適用。',
    policy: '預約政策',
    policyHelper: '選擇定義預約規則（時間、模式、費用行為）的政策預設。選「系統預設」以使用預設政策。',
    useSystemDefault: '系統預設',
    default: '預設',
    refundBehavior: '退款行為',
  },
  status: {
    pending: '待處理',
    applied: '已套用',
    cancelled: '已取消',
    failed: '失敗',
  },
};